import {unref} from 'vue'

/**
 * Scroll into view composable
 */
export function useScrollIntoView() {

  //Scroll into view
  const scrollIntoView = (element, options = {}) => {

    //Unref
    element = unref(element)
    if (!element) {
      return
    }

    //Extract options
    //These default values will align the element to the top of the container
    const {
      behavior = 'smooth',
      block = 'start',
      inline = 'nearest',
    } = options

    //Vue component
    if (element.$el) {
      element = element.$el
    }

    //Scroll into view
    if (typeof element.scrollIntoView === 'function') {
      element.scrollIntoView({behavior, block, inline})
    }
  }

  //Expose interface
  return {
    scrollIntoView,
  }
}
